<template>
  <div class="flex h-full w-full flex-col gap-4 p-2">
    <Header />

    <div role="main" class="mx-auto flex w-80 flex-col gap-4 sm:w-96">
      <EditorIsland class="flex flex-col gap-2">
        <p class="mb-4 text-center text-gray-600">
          <i-material-symbols:login /> Melde dich mit deinem
          <Button class="whitespace-nowrap underline" :label="prettyBaseUrl" :href="config.public.moodle.baseUrl">{{
            prettyBaseUrl
          }}</Button>
          Konto an.
        </p>
        <form class="flex flex-col gap-2" @submit.prevent="login">
          <FormField label="Anmeldename">
            <FormText
              id="username"
              v-model="username"
              aria-label="Anmeldename"
              placeholder="Anmeldename"
              required
              autocomplete="username"
              @invalid="$event.target.setCustomValidity('Bitte Feld ausfüllen')"
              @input="$event.target.setCustomValidity('')"
            />
          </FormField>
          <FormField label="Kennwort">
            <FormText
              id="password"
              v-model="password"
              type="password"
              aria-label="Kennwort"
              placeholder="Kennwort"
              required
              autocomplete="current-password"
              @invalid="$event.target.setCustomValidity('Bitte Feld ausfüllen')"
              @input="$event.target.setCustomValidity('')"
            />
          </FormField>
          <div class="flex h-full w-full items-center justify-center">
            <Patternlock @update-password="password = $event" />
          </div>
          <GrayButton label="Anmelden" type="submit" :loading="isAuthenticating" />
        </form>
      </EditorIsland>
      <EditorIsland v-if="errorMessage" class="flex font-bold text-red-600">
        {{ errorMessage }}
      </EditorIsland>
    </div>

    <Footer />
  </div>
</template>

<script setup lang="ts">
import { FetchError } from 'ofetch';

const username = ref('');
const password = ref('');
const isAuthenticating = ref(false);
const auth = useAuth();
const errorMessage = ref<string | null>(null);

const config = useRuntimeConfig();
const prettyBaseUrl = computed(() => new URL(config.public.moodle.baseUrl).host);

async function login() {
  isAuthenticating.value = true;
  errorMessage.value = null;
  try {
    await auth.login(username.value, password.value);
    await navigateTo('/');
  } catch (error) {
    if (error instanceof FetchError) {
      errorMessage.value = error.data.message;
    } else {
      errorMessage.value = 'Anmeldung fehlgeschlagen';
      throw createError(error as Error);
    }
  } finally {
    isAuthenticating.value = false;
  }
}
</script>
